import axios from "../../axios";

const getHiddenPayIns = async function (accessToken, params = {}) {
    try {
        const response = await axios.post('admin/pay-in/getHiddenPayIns', params, {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response?.status,
            message: e.response?.data?.message || e.message
        }
    }
}

export default getHiddenPayIns;
